var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-dropdown',_vm._b({attrs:{"visible":_vm.visible}},'a-dropdown',_vm.options,false),[_vm._t("default"),_vm._t("overlay",null,{"slot":"overlay"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }